import axios from './utils/axios';

var cancelTokens = {};

export var get = function get(date) {
  cancelTokens.get = require('axios').CancelToken.source();
  var endpoint = '/my-calendar/' + date;
  return axios.get(endpoint, { cancelToken: cancelTokens.get.token });
};

export var getRange = function getRange(dateFrom, dateTo) {
  cancelTokens.getRange = require('axios').CancelToken.source();
  var endpoint = '/my-calendar/' + dateFrom + '/to/' + dateTo;
  return axios.get(endpoint, { cancelToken: cancelTokens.getRange.token });
};

export var getWeeklyWorkload = function getWeeklyWorkload(date) {
  cancelTokens.getWeeklyWorkload = require('axios').CancelToken.source();
  var endpoint = '/my-calendar/' + date + '/week-workload';
  return axios.get(endpoint, { cancelToken: cancelTokens.getWeeklyWorkload.token });
};

export var synchronize = function synchronize(email) {
  var endpoint = '/calendar/full-sync/' + email;
  return axios.post(endpoint);
};

export var cancel = function cancel(method) {
  if (cancelTokens[method] && cancelTokens[method].cancel) {
    cancelTokens[method].cancel();
  }
};
//# sourceMappingURL=calendar.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/calendar.js
// module id = 1072
// module chunks = 0